<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>

        </div>
        <div class="transaction-section-header-actions header-actions">
          <!-- <button
          [class.ViewModeHiddenElement]="_pageState != 2"
          class="hidden-xs asap-btn"
          kendoButton
          (click)="_editFormState()"
          >
          <span
            ><img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" /></span
            >Edit Form
          </button> -->
          <!-- <button
          [class.ViewModeHiddenElement]="_pageState != 4"
          class="hidden-xs asap-btn"
          kendoButton
          (click)="_returnAddNew()"
          >
          <span
            ><img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" /></span
            >Close Edit Form
          </button> -->
          <button class="hidden-xs asap-btn" kendoButton (click)="_printReceiptReport()">
            <span><img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span>Print
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_OpenSignAndProcessForm()">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Sign & Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_OpenCreateShippingAndProcessForm()">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Carrier Shipping
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-12 ">
      <div class="transactionWidget">
        <div class="row no-row-margin">
          <div class="col-12 col-lg-6 zeroPaddingColumn">
            <div class="row">
              <div class="col-12">
                <p class="titleStandardStyle">General Information</p>
              </div>
              @if (_currentUser && _currentUser.isEnterprise) {
                <div class="col-12">
                  <div class="form-group special_style_formgroup">
                    <div class="row">
                      <div class="col-2"><label class="control-label">Account</label></div>
                      <div class="col-10 transaction--input-fields">
                        <accounts-dropdown #kendo_combo_accounts
                          [formControl]="_selectedAccount"
                          class="bordered current-step newFormControlWidth"
                          [class.active]="_selectedAccount.value == null"
                          [required]="true">
                        </accounts-dropdown>
                      </div>
                    </div>
                    <div class="transaction--stock-right-checkbox empty-small"></div>
                  </div>
                </div>
              }
              <sites-dropdown #kendo_combo_sites
                layout="transaction"
                [forceShow]="_isMultiSiteSelected"
                [labelText]="'Site'"
                [inputContainerClass]="'transaction--input-fields'"
                formControlName="site"
                [placeholder]="'Choose a Site'"
                [textField]="'name'"
                [valueField]="'id'"
                [class]="'bordered current-step newFormControlWidth'"
                [required]="true">
              </sites-dropdown>
              <div class="col-12">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <!-- <div class="col-2"><label class="control-label">{{_shipAgainstSO ? 'Sales Order'
                  : 'Pack List #'}}</label></div> -->
                  <div class="col-2">
                    @if (!_shipAgainstSO) {
                      <label class="control-label">{{getLabel('LBL_PackListNumber')?.currentText}}</label>
                    }
                    @if (_shipAgainstSO) {
                      <label class="control-label">{{getLabel('LBL_SalesOrder')?.currentText}}</label>
                    }
                  </div>
                  <div class="col-10 transaction--input-fields">
                    @if (!_shipAgainstSO) {
                      <kendo-combobox #kendo_combo_Pack_list
                        [data]="_packListFiltered" [filterable]="true" [suggest]="true"
                        formControlName="packList"
                        (selectionChange)="_handlePackListsSelection($event)"
                        [placeholder]="'Choose a Pack List #'" [textField]="'packingListNumber'"
                        [valueField]="'id'" class="bordered" required>
                      </kendo-combobox>
                    }
                    @if (!_shipAgainstSO) {
                      <a
                        [class.editfieldsIconvisible]="_pageState == 4"
                        class="editFieldsIcon"
                        (click)="_openRenameForm('LBL_PackListNumber', false, true)">
                        <img class="searchIcon"
                          style="margin-left:30px;"
                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      }
                      @if (_shipAgainstSO) {
                        <kendo-combobox #kendo_combo_Pack_list
                          [data]="_packListFiltered" [filterable]="true" [suggest]="true"
                          formControlName="salesOrder"
                          (selectionChange)="_handlePackListsSelection($event)"
                          [placeholder]="'Choose a Sales Order'" [textField]="'Concat'"
                          [valueField]="'transactionNumber'" class="bordered" required>
                        </kendo-combobox>
                      }
                      @if (_shipAgainstSO) {
                        <a
                          [class.editfieldsIconvisible]="_pageState == 4"
                          class="editFieldsIcon"
                          (click)="_openRenameForm('LBL_SalesOrder', false, true)">
                          <img class="searchIcon"
                            style="margin-left:30px;"
                            [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                          </a>
                        }
                      </div>
                    </div>
                    <div class="transaction--stock-right-checkbox empty-small"></div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup">
                    <div class="row">
                      <div class="col-2"><label class="control-label">{{getLabel('LBL_TransactionNotes')?.currentText}}</label></div>
                      <div class="col-10 transaction--input-fields">
                        <input #Kendo_Input_Transaction_note type="text" formControlName="notes"
                          class="k-textbox writebox newFormControlWidth"
                          (focus)="_focustransactionNotes()"
                          (focusout)="_focusOutTransactionNotes()"
                          placeholder="Transaction Notes.." />
                          <span class="inputSkipButton" (click)="_skipTransactionNotes()">
                            skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                          </span>
                          <a [class.editfieldsIconvisible]="_pageState == 4"
                            class="editFieldsIcon"
                            (click)="_openRenameForm('LBL_TransactionNotes', false, true)">
                            <img class="searchIcon"
                              style="margin-left:30px;"
                              [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                            </a>
                          </div>
                        </div>
                        <div class="transaction--stock-right-checkbox empty-small"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="transactionWidget with-grid numericboxtab" [class.active]="_addClassActive">
              <div class="flex-space-between transaction--grid-header-wrapper">
                <p class="titleStandardStyle">Selected Items</p>
                <div class="transaction--grid-top-actions">
                  <div class="transaction--grid-top-actions-radio">
                    <input type="radio" id="new-to-old-items" name="transaction--duration" value="new"
                      [formControl]="_sortingSelected" kendoRadioButton />
                      <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                    </div>
                    <div class="transaction--grid-top-actions-radio">
                      <input type="radio" id="old-to-new-items" name="transaction--duration" value="old"
                        [formControl]="_sortingSelected" kendoRadioButton />
                        <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                      </div>
                    </div>
                  </div>

                  <kendo-grid [data]="_inventoryGridData" [scrollable]="'none'" class="transaction--grid">

                    <kendo-grid-column field="transactionNumber" title="Transaction #">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.transactionNumber | number: '9.0' | removeComma}}
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="historyDate" title="History Date">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.historyDate | dateFormat}}
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="inventoryCode" title="Inventory ID">
                    </kendo-grid-column>

                    <kendo-grid-column field="itemNumber" title="Stock Item #">
                    </kendo-grid-column>

                    <kendo-grid-column field="locationCode" title="Location ID">
                    </kendo-grid-column>

                    <kendo-grid-column field="customerCode" title="Customer ID">
                    </kendo-grid-column>

                    <kendo-grid-column field="soNumber" title="Sales Order #">
                    </kendo-grid-column>

                  </kendo-grid>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 15px;">
              <div class="col-12 d-flex gap-2">
                <button kendoButton class="asap-btn" (click)="_OpenCreateShippingAndProcessForm()">
                  <span><img [src]="'/assets/menu/'+ _theme +'/sign-create-label-ship.svg'" /></span>Sign, Create Carrier Label & Process
                </button>
                <button kendoButton class="asap-btn" (click)="_OpenSignAndProcessForm()">
                  <span><img [src]="'/assets/menu/'+ _theme +'/process-ship.svg'" /></span>Sign & Process
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                @if (_invalidForm) {
                  <asap-forms-validation-summary [form]="_form" [page]="'ship'">
                  </asap-forms-validation-summary>
                }
              </div>
            </div>
          </form>

          @if (OpenSignAndProcessForm) {
            <kendo-window title="SIGN & PROCESS" (close)="_closeSignAndProcessForm()"
              (stateChange)="_onStateChanges($event)" class="fullWidthFormForm">
              <form novalidate [formGroup]="_form_signAndProcess" (keydown.enter)="$event.preventDefault()" class="form_style">
                <div class="row no-row-margin">
                  <div class="col-12 ">
                    <div class="transactionWidget">
                      <div class="row no-row-margin martop-0">
                        <div class="col-12 col-lg-6 zeroPaddingColumn">
                          <div class="row">
                            <div class="col-12">
                              <p class="titleStandardStyle">Signature Assigned by</p>
                            </div>
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Person ID</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <kendo-combobox #kendo_combo_Person_ID
                                      [data]="_personsFiltered"
                                      [filterable]="true"
                                      (valueChange)="_personIDChange()"
                                      (filterChange)="_handlePersonsFilter($event)"
                                      [suggest]="true" formControlName="person"
                                      [placeholder]="'Choose a Person ID'"
                                      [textField]="'code'" [valueField]="'id'"
                                      (open)="_personIDOpenEvent()"
                                      class="current-step newFormControlWidth bordered" required>
                                    </kendo-combobox>
                                  </div>
                                </div>
                                <div class="transaction--stock-right-checkbox empty-small"></div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Notes</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <input #Kendo_Input_Notes type="text"
                                      class="k-textbox newFormControlWidth" (focus)="_focusNotes()"
                                      (focusout)="_focusOutNotes()" placeholder="Notes.." />
                                      <span class="inputSkipButton" (click)="_skipNotes()">
                                        skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                                      </span>
                                    </div>
                                  </div>
                                  <div class="transaction--stock-right-checkbox empty-small"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row col-12 col-lg-6">
                            <div class="col-8"></div>
                            <div class="col-4">
                              <button kendoButton class="steps_buttons_class" (click)="_closeSignAndProcessForm()">
                                <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                <span>Close</span>
                              </button>
                              <button kendoButton class="steps_buttons_class" (click)="_onSave($event)">
                                <img class="backimage" [src]="'/assets/menu/'+ _theme +'/process-ship.svg'" />
                                <span>Process </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <asap-signature #signature class="shipSignature" [class.active]="_addClassActive"></asap-signature>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      @if (_invalidForm_signAndProcess) {
                        <asap-forms-validation-summary [form]="_form_signAndProcess"
                          [page]="'ship'">
                        </asap-forms-validation-summary>
                      }
                    </div>
                  </div>
                </form>
              </kendo-window>
            }

            @if (OpenCreateShippingAndProcessForm) {
              <kendo-window title="SIGN, CREATE LABEL SHIPPING & PROCESS"
                (close)="_closeCreateShippingAndProcessForm()" (stateChange)="_onStateChanges($event)" class="fullWidthFormForm">
                <div class="row no-row-margin">
                  <div class="col-12 ">
                    <div class="transactionWidget">
                      <div class="row no-row-margin martop-0">
                        <div class="col-12 zeroPaddingColumn">
                          <p class="titleStandardStyle">Select Shipper</p>
                        </div>
                        <div class="col-12 zeroPaddingColumn">
                          <ul class="row no-row-margin martop-0 imageCheckbox">
                            <li class="col-12 col-lg-4 zeroPaddingColumn">
                              <input class="imageinputCheckbox" type="radio" name="carrierSelection" id="carrierUPS" value="UPS" [checked]="_selectedCarrier === 'UPS'" (change)="_onCarrierChange('UPS')" />
                              <label class="imagecheckboxLabel" [class.selected]="_selectedCarrier === 'UPS'" for="carrierUPS" (click)="_onCarrierChange('UPS')">
                                <img [src]="'/assets/menu/'+ _theme +'/UPS-icon.png'" alt="UPS" />
                              </label>
                            </li>
                            <li class="col-12 col-lg-4 zeroPaddingColumn">
                              <input class="imageinputCheckbox" type="radio" name="carrierSelection" id="carrierFedEx" value="FedEx" [checked]="_selectedCarrier === 'FedEx'" (change)="_onCarrierChange('FedEx')" />
                              <label class="imagecheckboxLabel" [class.selected]="_selectedCarrier === 'FedEx'" for="carrierFedEx" (click)="_onCarrierChange('FedEx')">
                                <img [src]="'/assets/menu/'+ _theme +'/fedex-icon.png'" alt="FedEx" />
                              </label>
                            </li>
                            <li class="col-12 col-lg-4 zeroPaddingColumn">
                              <input class="imageinputCheckbox" type="radio" name="carrierSelection" id="carrierDHL" value="DHL" [checked]="_selectedCarrier === 'DHL'" (change)="_onCarrierChange('DHL')" />
                              <label class="imagecheckboxLabel" [class.selected]="_selectedCarrier === 'DHL'" for="carrierDHL" (click)="_onCarrierChange('DHL')">
                                <img [src]="'/assets/menu/'+ _theme +'/dhl-icon.png'" alt="DHL" />
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="transactionWidget">
                      <div class="row no-row-margin martop-0">
                        <div class="col-12 zeroPaddingColumn">
                          <p class="titleStandardStyle">Shipment Details ({{_selectedCarrier || 'No Carrier Selected'}})</p>
                        </div>
                        <div class="col-12 col-lg-4 zeroPaddingColumn">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Drop Off Type</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <kendo-combobox [data]="_dropOffTypes"
                                      [(ngModel)]="_selectedDropOffType"
                                      [filterable]="true" [suggest]="true"
                                      [placeholder]="'Choose Drop Off Type'"
                                      class="current-step newFormControlWidth">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Ship Date</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <kendo-datepicker [(ngModel)]="_shippingShipDate"
                                      type="text" class="newFormControlWidth k-datepicker"
                                      [format]="_datePickerFormat">
                                    </kendo-datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-lg-4 zeroPaddingColumn">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Service Type</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <kendo-combobox [data]="_serviceTypes"
                                      [(ngModel)]="_selectedServiceType"
                                      [filterable]="true" [suggest]="true"
                                      [placeholder]="'Choose Service Type'"
                                      class="current-step newFormControlWidth">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Signature Option</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <kendo-combobox [data]="_signatureOptions"
                                      [(ngModel)]="_selectedSignatureOption"
                                      [filterable]="true" [suggest]="true"
                                      [placeholder]="'Choose Signature Option'"
                                      class="current-step newFormControlWidth">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-lg-4 zeroPaddingColumn">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Packaging Type</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <kendo-combobox [data]="_packagingTypes"
                                      [(ngModel)]="_selectedPackagingType"
                                      [filterable]="true" [suggest]="true"
                                      [placeholder]="'Choose Packaging Type'"
                                      class="current-step newFormControlWidth">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group special_style_formgroup">
                                <div class="row">
                                  <div class="col-2"><label class="control-label">Insured Value $</label></div>
                                  <div class="col-10 transaction--input-fields">
                                    <input type="text" [(ngModel)]="_shippingInsuredValue"
                                      class="k-textbox writebox newFormControlWidth"
                                      placeholder="Insured Value" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="transactionWidget">
                        <div class="row no-row-margin martop-0">
                          <div class="col-12 zeroPaddingColumn">
                            <p class="titleStandardStyle">Package & Reference Details</p>
                          </div>
                          <div class="col-12 col-lg-4 zeroPaddingColumn">
                            <div class="row">
                              <div class="col-12">
                                <div class="form-group special_style_formgroup">
                                  <div class="row">
                                    <div class="col-2"><label class="control-label"># of Packaging</label></div>
                                    <div class="col-10 transaction--input-fields">
                                      <kendo-numerictextbox [(ngModel)]="_shippingNumPackages"
                                        class="k-numerictextbox newFormControlWidth" [min]="1">
                                      </kendo-numerictextbox>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="form-group special_style_formgroup">
                                  <div class="row">
                                    <div class="width-70">
                                      <div class="imbiddedNumericBox br-none">
                                        <label class="control-label">Length(in)</label>
                                        <kendo-numerictextbox [(ngModel)]="_shippingLength"
                                          class="k-numerictextbox shipsmalNumeric" [min]="0">
                                        </kendo-numerictextbox>
                                      </div>
                                      <div class="imbiddedNumericBox br-none">
                                        <label class="control-label">Width(in)</label>
                                        <kendo-numerictextbox [(ngModel)]="_shippingWidth"
                                          class="k-numerictextbox shipsmalNumeric" [min]="0">
                                        </kendo-numerictextbox>
                                      </div>
                                      <div class="imbiddedNumericBox br-none">
                                        <label class="control-label">Height(in)</label>
                                        <kendo-numerictextbox [(ngModel)]="_shippingHeight"
                                          class="k-numerictextbox shipsmalNumeric" [min]="0">
                                        </kendo-numerictextbox>
                                      </div>
                                      <div class="imbiddedNumericBox br-none">
                                        <label class="control-label">Weight(lbs)</label>
                                        <kendo-numerictextbox [(ngModel)]="_shippingWeightLbs"
                                          class="k-numerictextbox shipsmalNumeric" [min]="0">
                                        </kendo-numerictextbox>
                                      </div>
                                      <div class="imbiddedNumericBox">
                                        <label class="control-label">Weight(oz)</label>
                                        <kendo-numerictextbox [(ngModel)]="_shippingWeightOz"
                                          class="k-numerictextbox shipsmalNumeric" [min]="0">
                                        </kendo-numerictextbox>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-4 zeroPaddingColumn">
                            <div class="row">
                              <div class="col-12">
                                <div class="form-group special_style_formgroup">
                                  <div class="row">
                                    <div class="col-2"><label class="control-label">Customer Ref Type</label></div>
                                    <div class="col-10 transaction--input-fields">
                                      <kendo-combobox [data]="_customerRefTypes"
                                        [(ngModel)]="_selectedCustomerRefType"
                                        [filterable]="true" [suggest]="true"
                                        [placeholder]="'Choose Customer Ref Type'"
                                        class="current-step newFormControlWidth">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-4 zeroPaddingColumn">
                            <div class="row">
                              <div class="col-12">
                                <div class="form-group special_style_formgroup">
                                  <div class="row">
                                    <div class="col-2"><label class="control-label">Customer Ref Value</label></div>
                                    <div class="col-10 transaction--input-fields">
                                      <input type="text" [(ngModel)]="_shippingCustomerRefValue"
                                        class="k-textbox writebox newFormControlWidth"
                                        placeholder="Customer Ref Value" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="transactionWidget">
                          <div class="row no-row-margin martop-0">
                            <div class="col-12 zeroPaddingColumn">
                              <p class="titleStandardStyle">Payment Information</p>
                            </div>
                            <div class="col-12 col-lg-4 zeroPaddingColumn">
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group special_style_formgroup">
                                    <div class="row">
                                      <div class="col-2">
                                        <label class="control-label">Payment Type</label>
                                      </div>
                                      <div class="col-10 transaction--input-fields">
                                        <kendo-combobox [data]="_paymentTypes"
                                          [(ngModel)]="_selectedPaymentType"
                                          [filterable]="true" [suggest]="true"
                                          [placeholder]="'Choose Payment Type'"
                                          class="current-step newFormControlWidth">
                                        </kendo-combobox>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-lg-4 zeroPaddingColumn">
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group special_style_formgroup">
                                    <div class="row">
                                      <div class="col-2"><label class="control-label">Account #</label></div>
                                      <div class="col-10 transaction--input-fields">
                                        <input type="text" [(ngModel)]="_shippingAccountNumber"
                                          class="k-textbox writebox newFormControlWidth"
                                          [placeholder]="_selectedCarrier ? _selectedCarrier + ' Account #' : 'Account Number'" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  @if (_selectedCarrier === 'FedEx') {
                                    <div class="col-12">
                                      <div class="form-group special_style_formgroup">
                                        <div class="row">
                                          <div class="col-2"><label class="control-label">Meter #</label></div>
                                          <div class="col-10 transaction--input-fields">
                                            <input type="text" [(ngModel)]="_shippingMeterNumber"
                                              class="k-textbox writebox newFormControlWidth"
                                              placeholder="FedEx Meter Number" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>
                                <div class="col-12 col-lg-4 zeroPaddingColumn">
                                  <div class="row">
                                    <div class="col-12">
                                      <div class="form-group special_style_formgroup">
                                        <div class="row">
                                          <div class="col-2"><label class="control-label">Country Code</label></div>
                                          <div class="col-10 transaction--input-fields">
                                            <input type="text" [(ngModel)]="_shippingCountryCode"
                                              class="k-textbox writebox newFormControlWidth"
                                              placeholder="Country Code (e.g. US)" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="transactionWidget">
                                <div class="row no-row-margin martop-0">
                                  <div class="col-12 zeroPaddingColumn">
                                    <p class="titleStandardStyle">Shipper Information</p>
                                  </div>
                                  <div class="col-12 col-lg-4 zeroPaddingColumn">
                                    <div class="row">
                                      <div class="col-12">
                                        <div class="form-group special_style_formgroup">
                                          <div class="row">
                                            <div class="col-2"><label class="control-label">Name</label></div>
                                            <div class="col-10 transaction--input-fields">
                                              <input type="text" [(ngModel)]="_shippingSender.name"
                                                class="k-textbox writebox newFormControlWidth"
                                                placeholder="Name" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12">
                                          <div class="form-group special_style_formgroup">
                                            <div class="row">
                                              <div class="col-2"><label class="control-label">Company</label></div>
                                              <div class="col-10 transaction--input-fields">
                                                <input type="text" [(ngModel)]="_shippingSender.company"
                                                  class="k-textbox writebox newFormControlWidth"
                                                  placeholder="Company" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12">
                                            <div class="form-group special_style_formgroup">
                                              <div class="row">
                                                <div class="col-2"><label class="control-label">Phone</label></div>
                                                <div class="col-10 transaction--input-fields">
                                                  <input type="text" [(ngModel)]="_shippingSender.phone"
                                                    class="k-textbox writebox newFormControlWidth"
                                                    placeholder="Phone" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-12">
                                              <div class="form-group special_style_formgroup">
                                                <div class="row">
                                                  <div class="col-2"><label class="control-label">Email</label></div>
                                                  <div class="col-10 transaction--input-fields">
                                                    <input type="text" [(ngModel)]="_shippingSender.email"
                                                      class="k-textbox writebox newFormControlWidth"
                                                      placeholder="Email" />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12 col-lg-4 zeroPaddingColumn">
                                            <div class="row">
                                              <div class="col-12">
                                                <div class="form-group special_style_formgroup">
                                                  <div class="row">
                                                    <div class="col-2"><label class="control-label">Address 1</label></div>
                                                    <div class="col-10 transaction--input-fields">
                                                      <input type="text" [(ngModel)]="_shippingSender.address1"
                                                        class="k-textbox writebox newFormControlWidth"
                                                        placeholder="Address 1" />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-12">
                                                  <div class="form-group special_style_formgroup">
                                                    <div class="row">
                                                      <div class="col-2"><label class="control-label">Address 2</label></div>
                                                      <div class="col-10 transaction--input-fields">
                                                        <input type="text" [(ngModel)]="_shippingSender.address2"
                                                          class="k-textbox writebox newFormControlWidth"
                                                          placeholder="Address 2" />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-12">
                                                    <div class="form-group special_style_formgroup">
                                                      <div class="row">
                                                        <div class="col-2"><label class="control-label">City</label></div>
                                                        <div class="col-10 transaction--input-fields">
                                                          <input type="text" [(ngModel)]="_shippingSender.city"
                                                            class="k-textbox writebox newFormControlWidth"
                                                            placeholder="City" />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-12 col-lg-4 zeroPaddingColumn">
                                                  <div class="row">
                                                    <div class="col-12">
                                                      <div class="form-group special_style_formgroup">
                                                        <div class="row">
                                                          <div class="col-2"><label class="control-label">State</label></div>
                                                          <div class="col-10 transaction--input-fields">
                                                            <input type="text" [(ngModel)]="_shippingSender.state"
                                                              class="k-textbox writebox newFormControlWidth"
                                                              placeholder="State" />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-12">
                                                        <div class="form-group special_style_formgroup">
                                                          <div class="row">
                                                            <div class="col-2"><label class="control-label">Zip</label></div>
                                                            <div class="col-10 transaction--input-fields">
                                                              <input type="text" [(ngModel)]="_shippingSender.zip"
                                                                class="k-textbox writebox newFormControlWidth"
                                                                placeholder="Zip" />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="col-12">
                                                          <div class="form-group special_style_formgroup">
                                                            <div class="row">
                                                              <div class="col-2"><label class="control-label">Country</label></div>
                                                              <div class="col-10 transaction--input-fields">
                                                                <input type="text" [(ngModel)]="_shippingSender.country"
                                                                  class="k-textbox writebox newFormControlWidth"
                                                                  placeholder="Country" />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="transactionWidget">
                                                    <div class="row no-row-margin martop-0">
                                                      <div class="col-12 zeroPaddingColumn">
                                                        <p class="titleStandardStyle">Recipient Information</p>
                                                      </div>
                                                      <div class="col-12 col-lg-4 zeroPaddingColumn">
                                                        <div class="row">
                                                          <div class="col-12">
                                                            <div class="form-group special_style_formgroup">
                                                              <div class="row">
                                                                <div class="col-2"><label class="control-label">Name</label></div>
                                                                <div class="col-10 transaction--input-fields">
                                                                  <input type="text" [(ngModel)]="_shippingRecipient.name"
                                                                    class="k-textbox writebox newFormControlWidth"
                                                                    placeholder="Name" />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div class="col-12">
                                                              <div class="form-group special_style_formgroup">
                                                                <div class="row">
                                                                  <div class="col-2"><label class="control-label">Company</label></div>
                                                                  <div class="col-10 transaction--input-fields">
                                                                    <input type="text" [(ngModel)]="_shippingRecipient.company"
                                                                      class="k-textbox writebox newFormControlWidth"
                                                                      placeholder="Company" />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div class="col-12">
                                                                <div class="form-group special_style_formgroup">
                                                                  <div class="row">
                                                                    <div class="col-2"><label class="control-label">Phone</label></div>
                                                                    <div class="col-10 transaction--input-fields">
                                                                      <input type="text" [(ngModel)]="_shippingRecipient.phone"
                                                                        class="k-textbox writebox newFormControlWidth"
                                                                        placeholder="Phone" />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div class="col-12">
                                                                  <div class="form-group special_style_formgroup">
                                                                    <div class="row">
                                                                      <div class="col-2"><label class="control-label">Email</label></div>
                                                                      <div class="col-10 transaction--input-fields">
                                                                        <input type="text" [(ngModel)]="_shippingRecipient.email"
                                                                          class="k-textbox writebox newFormControlWidth"
                                                                          placeholder="Email" />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div class="col-12 col-lg-4 zeroPaddingColumn">
                                                                <div class="row">
                                                                  <div class="col-12">
                                                                    <div class="form-group special_style_formgroup">
                                                                      <div class="row">
                                                                        <div class="col-2"><label class="control-label">Address 1</label></div>
                                                                        <div class="col-10 transaction--input-fields">
                                                                          <input type="text" [(ngModel)]="_shippingRecipient.address1"
                                                                            class="k-textbox writebox newFormControlWidth"
                                                                            placeholder="Address 1" />
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-12">
                                                                      <div class="form-group special_style_formgroup">
                                                                        <div class="row">
                                                                          <div class="col-2"><label class="control-label">Address 2</label></div>
                                                                          <div class="col-10 transaction--input-fields">
                                                                            <input type="text" [(ngModel)]="_shippingRecipient.address2"
                                                                              class="k-textbox writebox newFormControlWidth"
                                                                              placeholder="Address 2" />
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div class="col-12">
                                                                        <div class="form-group special_style_formgroup">
                                                                          <div class="row">
                                                                            <div class="col-2"><label class="control-label">City</label></div>
                                                                            <div class="col-10 transaction--input-fields">
                                                                              <input type="text" [(ngModel)]="_shippingRecipient.city"
                                                                                class="k-textbox writebox newFormControlWidth"
                                                                                placeholder="City" />
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-12 col-lg-4 zeroPaddingColumn">
                                                                      <div class="row">
                                                                        <div class="col-12">
                                                                          <div class="form-group special_style_formgroup">
                                                                            <div class="row">
                                                                              <div class="col-2"><label class="control-label">State</label></div>
                                                                              <div class="col-10 transaction--input-fields">
                                                                                <input type="text" [(ngModel)]="_shippingRecipient.state"
                                                                                  class="k-textbox writebox newFormControlWidth"
                                                                                  placeholder="State" />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div class="col-12">
                                                                            <div class="form-group special_style_formgroup">
                                                                              <div class="row">
                                                                                <div class="col-2"><label class="control-label">Zip</label></div>
                                                                                <div class="col-10 transaction--input-fields">
                                                                                  <input type="text" [(ngModel)]="_shippingRecipient.zip"
                                                                                    class="k-textbox writebox newFormControlWidth"
                                                                                    placeholder="Zip" />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div class="col-12">
                                                                              <div class="form-group special_style_formgroup">
                                                                                <div class="row">
                                                                                  <div class="col-2"><label class="control-label">Country</label></div>
                                                                                  <div class="col-10 transaction--input-fields">
                                                                                    <input type="text" [(ngModel)]="_shippingRecipient.country"
                                                                                      class="k-textbox writebox newFormControlWidth"
                                                                                      placeholder="Country" />
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div class="row">
                                                                    <div class="col-12">
                                                                      <button kendoButton class="steps_buttons_class" (click)="_closeCreateShippingAndProcessForm()">
                                                                        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                                                        <span>Close</span>
                                                                      </button>
                                                                    </div>
                                                                  </div>
                                                                </kendo-window>
                                                              }

                                                              @if (_editFormActive) {
                                                                <kendo-window
                                                                  title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record: ' +_selectedLabelText : '')) }}"
                                                                  (close)="_closeCustomFields()"
                                                                  class="customFieldsWindow">
                                                                  <asap-custom-fields [accounts]="_selectedAccountIds"
                                                                    [labelObjectCode]="_selectedLabelObjectCode"
                                                                    [formName]="'stock'"
                                                                    [page]="_page"
                                                                    [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                                                    [isCustomtabsForm]="_isAddTabFormValue"
                                                                    [isRenameForm]="_isRenameFormValue"
                                                                    [language]="_language"
                                                                    [isRenameCustomForm]="_isRenameCustomFormValue"
                                                                    [onlyRequired]="_onlyRequired"
                                                                    [hasRequired]="_hasRequired"
                                                                    [isRenameLabel]="_isRenameLabel"
                                                                    [isMandatory]="_isMandatory"
                                                                    [isTransaction]="_isTransaction"
                                                                    (closePopup)="ClosePopup($event)"
                                                                    [permissionScope]="'packTransaction'">
                                                                  </asap-custom-fields>
                                                                </kendo-window>
                                                              }
